// extracted by mini-css-extract-plugin
module.exports = {"heroCardsContainer":"HeroCards_heroCardsContainer__Drn0P","heroCards":"HeroCards_heroCards__HNJhP"};